document.addEventListener('DOMContentLoaded', function () {
  /* ---- Mobile nav toggle ---- */
  var menuToggle = document.getElementById('mobile-menu-toggle');
  var siteNav = document.getElementById('site-nav');
  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', function () {
      siteNav.classList.toggle('is-open');
      siteNav.style.display = siteNav.classList.contains('is-open') ? 'block' : '';
    });
  }

  /* ---- Search overlay ---- */
  var searchToggle = document.getElementById('search-toggle');
  var searchOverlay = document.getElementById('search-overlay');
  var searchClose = document.getElementById('search-close');
  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function () {
      searchOverlay.classList.add('is-active');
      var input = searchOverlay.querySelector('input');
      if (input) input.focus();
    });
  }
  if (searchClose) {
    searchClose.addEventListener('click', function () {
      searchOverlay.classList.remove('is-active');
    });
  }

  /* ---- Product page thumbnail swap ---- */
  document.querySelectorAll('.product-page__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById('ProductMainImage');
      if (main) main.src = thumb.getAttribute('data-full-src');
    });
  });

  /* ---- Cart drawer ---- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartToggle = document.getElementById('cart-toggle');
  var cartCloseEls = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    refreshCartDrawer();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  cartCloseEls.forEach(function (el) { el.addEventListener('click', closeCart); });

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var itemsEl = document.getElementById('cart-drawer-items');
        var subtotalEl = document.getElementById('cart-drawer-subtotal');
        if (!itemsEl) return;
        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<p>Your bag is empty.</p>';
        } else {
          itemsEl.innerHTML = cart.items.map(function (item) {
            return '<div class="cart-drawer__item" style="display:flex;gap:.8rem;margin-bottom:1rem;">' +
              '<img src="' + item.image + '" alt="" style="width:64px;height:64px;object-fit:cover;">' +
              '<div><a href="' + item.url + '" style="font-size:.85rem;">' + item.product_title + '</a>' +
              '<div style="font-size:.75rem;color:#8a7f6e;">Qty ' + item.quantity + ' — ' + formatMoney(item.line_price) + '</div></div>' +
              '</div>';
          }).join('');
        }
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- AJAX add to cart ---- */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { openCart(); })
        .catch(function () { productForm.submit(); });
    });
  }
});
